import React, { Component } from 'react';
import Tabs, { Panel } from 'react-simpletabs';

import SchoolInfo from './SchoolInfo';
import InstituteInfo from './InstituteInfo';
import './style.css';


export default class Education extends Component {
  render() {
    const classes = this.props.styleClasses ? this.props.styleClasses.join(' ') : '';
    return (
      <div className='form__info-block'>
        <div className='form__tips'>
          В день конференции при регистрации нужно подтвердить свой статус студенческим билетом или справкой школьника.
        </div>
        <Tabs className={classes} tabActive={this.props.instituteId ? 2 : 1}>
          <Panel title='я школьник'>
            <SchoolInfo
              schoolList={this.props.schoolList}
              gradeHandler={this.props.gradeHandler}
              clearFields={this.props.clearFields}
              styleEducation={'form__inputs_default'}
              schoolId={this.props.schoolId}
              grade={this.props.grade}
            />
          </Panel>
          <Panel title='я студент'>
            <InstituteInfo
              instituteList={this.props.instituteList}
              departmentHandler={this.props.departmentHandler}
              courseHandler={this.props.courseHandler}
              clearFields={this.props.clearFields}
              styleEducation={'form__inputs_default'}
              instituteId={this.props.instituteId}
              department={this.props.department}
              course={this.props.course}
            />
          </Panel>
        </Tabs>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/blocks/form-blocks/Education.js